/* Théa sticky ATC — 18/10/2026: visible from load on mobile (<750px); desktop keeps
   "show when the main buy button is out of view". Variant sync uses Dawn 15 pub/sub
   (PUB_SUB_EVENTS.variantChange) — the old 'variant:change' DOM event never fired. */
(function () {
  var bar = document.querySelector('[data-thea-sticky-atc]');
  if (!bar) return;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  var buy = document.querySelector('product-form .product-form__submit, .product-form__buttons, [name="add"]');
  var target = buy ? (buy.closest('.product-form') || buy) : null;
  var mainVisible = false;

  function apply() {
    var mobile = mq && mq.matches;
    bar.hidden = mobile ? false : mainVisible;
    document.body.classList.toggle('thea-has-sticky', !bar.hidden);
  }

  if (target && typeof IntersectionObserver !== 'undefined') {
    new IntersectionObserver(function (entries) {
      mainVisible = entries.some(function (e) { return e.isIntersecting; });
      apply();
    }, { threshold: 0.15 }).observe(target);
  }
  if (mq && mq.addEventListener) mq.addEventListener('change', apply);
  apply();

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    } catch (e) {}
    return '$' + (Number(cents) / 100).toFixed(2);
  }
  function update(v) {
    if (!v) return;
    var idInput = bar.querySelector('input[name="id"]');
    var price = bar.querySelector('.thea-sticky-atc__price');
    var btn = bar.querySelector('[name="add"]');
    if (idInput) idInput.value = v.id;
    if (price && v.price != null) price.textContent = money(v.price);
    if (btn) btn.disabled = !v.available;
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      update(event && event.data && event.data.variant);
    });
  }
  document.addEventListener('variant:change', function (event) {
    update(event.detail && event.detail.variant);
  });
})();
